import { JiraIntegrationForm } from '../jira-integration-page/jira-form-schema'
import {
  updateJiraBugtracker,
  UpdateJiraBugtrackerArgs
} from './requests/update-jira-bugtracker'
import { UseMutationOptions } from 'react-query'
import { useContrastMutation } from '../../../../hooks/use-contrast-mutation'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseUpdateJiraBugtrackerQueryProps {
  organizationUuid: string
  bugtracker: JiraIntegrationForm
  bugtrackerId?: number
}

export interface UpdateJiraBugtrackerQueryResponse {
  data: any | undefined
  error: Error | null
  isError: boolean
  isLoading: boolean
}

export type UseUpdateJiraBugtrackerQuery = (
  props: UseUpdateJiraBugtrackerQueryProps
) => UpdateJiraBugtrackerQueryResponse

export function useUpdateJiraBugtrackerQuery(
  options?: UseMutationOptions<
    UpdateJiraBugtrackerQueryResponse,
    Error,
    UpdateJiraBugtrackerArgs
  >
) {
  return useContrastMutation<
    UpdateJiraBugtrackerQueryResponse,
    HTTPError,
    UpdateJiraBugtrackerArgs
  >(updateJiraBugtracker, options)
}
